export default __webpack_public_path__ + "static/media/sample.9f2b537d.png";